import { Block as SuspendedIcon } from '@mui/icons-material'
import { Button } from '@mui/material'

import { EmptyState } from '@/components/shared/EmptyState'
import { SUSPENSION_CONTACT_EMAIL } from '@/modules/auth/authSlice'

/**
 * Shown in place of every page while the session's organisation is suspended by YOM staff
 * (API 403 ORG_SUSPENDED), instead of a page of failed requests. The top bar stays, so a
 * member of several organisations can switch or sign out.
 */
export function OrgSuspendedNotice() {
    return (
        <EmptyState
            icon={<SuspendedIcon />}
            title="This organisation is suspended"
            description={`Its dashboards, reports and settings are unavailable. To find out why or to restore access, contact ${SUSPENSION_CONTACT_EMAIL}.`}
            action={
                <Button variant="contained" href={`mailto:${SUSPENSION_CONTACT_EMAIL}`}>
                    Email {SUSPENSION_CONTACT_EMAIL}
                </Button>
            }
            sx={{ py: 12, px: 3 }}
        />
    )
}
